export default "__VITE_ASSET__DZrrf59p__"